import axios from "libs/axios";
import { useQuery, UseQueryOptions } from "react-query";

import { TransactionDTO } from "../type";
import { AxiosError } from "axios";
import { useSelector } from "react-redux";
import { useAppSelector } from "store";
interface transactionParams {
  TerminalId?: number;
  PageNumber: number;
  PageSize: number;
  FromDate: string;
  ToDate: string;
  BuyId?: string;
  TrackingNumber?: string;
}

export const getTransactions = async (param: transactionParams) => {
  console.log(param);
  return await axios
    .get<TransactionDTO>(`/api/v1/Transaction/get-by-terminal-id`, {
      params: { ...param, version: "1" },
    })
    .then((res) => res.data)
    .catch((err) => err.data);
};

export type UseTransactionsOptions = UseQueryOptions<
  TransactionDTO,
  AxiosError,
  TransactionDTO
>;
type useTerminalsOptions = {
  params: Omit<transactionParams, "AcceptorId">;
  options?: UseTransactionsOptions;
};
export const useTransactions = ({ params, options }: useTerminalsOptions) => {
  const { invalidateKey } = useAppSelector((state) => state.transactions);
  return useQuery({
    queryKey: [
      "/api/v1/Transaction/get-by-terminal-id",
      params.PageNumber,
      params.FromDate,
      params.ToDate,
      params.TerminalId,
      params?.TrackingNumber,
      params?.BuyId,
      invalidateKey,
    ],
    queryFn: () => getTransactions(params),
    enabled: !!params.TerminalId,
    ...options,
  });
};
